import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Account } from '../../../shared/account/account.types';

@Component({
  selector: 'app-account-modal',
  templateUrl: './account-modal.component.html',
  styleUrls: ['./account-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountModalComponent{

  @Input()
  public modalReference: NgbModalRef;

  @Input()
  public accountType: Account.Type;

  public closeModal() {
    this.modalReference.close();
  }
}
